/* Sticky-Kaufleiste

   Blendet eine schmale Leiste mit Preis, Variante und Kaufbutton ein, sobald
   der Hero-Kaufbereich aus dem Blick gescrollt ist. Spiegelt Auswahl und Menge
   in beide Richtungen, damit beide Formulare denselben Stand zeigen.

   Faellt bewusst still aus, wenn IntersectionObserver fehlt oder der Hero-
   Kaufbereich nicht gefunden wird — dann bleibt die Seite wie bisher. */

(function () {
  'use strict';

  function init(bar) {
    if (!bar || bar.dataset.stickyBuyReady === 'true') return;
    bar.dataset.stickyBuyReady = 'true';

    var watchSelector = bar.dataset.watch;
    var watched = watchSelector ? document.querySelector(watchSelector) : null;
    if (!watched || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sticky-buy--visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-72px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(watched);

    // The sticky form selects variant IDs; the hero selects option labels.
    // Resolve through the same variant data used for price, stock and delivery.
    var hero = watched.closest('[data-produktinformationen-section-id]');
    var variantData = hero && hero.querySelector('[data-produktinformationen-variant-options]');
    if (!hero || !variantData) return;
    var variants;
    try { variants = JSON.parse(variantData.textContent); } catch (_) { return; }
    var barSelect = bar.querySelector('[data-sticky-buy-variant]');
    var groups = hero.querySelectorAll('.produktinformationen-v2__variants .product-form__input');

    function sync(variant) {
      if (!variant) return;
      if (barSelect) barSelect.value = String(variant.id);
      var price = bar.querySelector('.sticky-buy__price');
      if (price) price.textContent = variant.price;
      var button = bar.querySelector('button[name="add"]');
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? hero.dataset.labelAdd : variant.prefunding || hero.dataset.labelSoldOut;
      }
    }

    if (barSelect) barSelect.addEventListener('change', function () {
      var variant = variants.find(function (item) { return String(item.id) === barSelect.value; });
      if (!variant) return;
      groups.forEach(function (group, index) {
        var select = group.querySelector('select');
        if (select) {
          select.value = variant.options[index];
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          var radio = Array.from(group.querySelectorAll('input[type="radio"]')).find(function (input) { return input.value === variant.options[index]; });
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      });
      sync(variant);
    });
    hero.addEventListener('citydesign:variant-change', function (event) {
      sync(variants.find(function (item) { return item.id === event.detail.id; }));
    });
    var selected = Array.from(groups).map(function (group) {
      var input = group.querySelector('select, input[type="radio"]:checked');
      return input && input.value;
    });
    sync(variants.find(function (item) { return item.options.every(function (value, index) { return value === selected[index]; }); }));
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
